import { fetchFromStrapi, fetchUrl } from "./api/fetchFromStrapi.js";

export function slugify(text) {
  if (text) {
    return text
      .toString()
      .normalize('NFD')                      // Decompose accented chars to ASCII equivalents
      .replace(/[\u0300-\u036f]/g, '')       // Remove diacritical marks
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")           // Replace all non-alphanumeric with '-'
      .replace(/(^-|-$)/g, "");
  } else {
    return "";
  }
}

export function getWebsiteType(isEditor) {
  if (isEditor) {
    const iframeElement = document.getElementById("preview-frame");
    if (!iframeElement || !iframeElement.contentWindow) return "petrotec";

    const iframe = iframeElement.contentWindow.document;
    if (!iframe || !iframe.body) return "petrotec";

    if (iframe.body.classList.contains("petrotec")) {
      return "petrotec";
    }
    if (iframe.body.classList.contains("petroassist")) {
      return "petroassist";
    }
    if (iframe.body.classList.contains("petrotec-group")) {
      return "petrotec-group";
    }
    return "petrotec";
  } else {
    if (typeof document == "undefined") {
      return process.env.WEBSITE_TYPE;
    } else {
      if (document.body.classList.contains("petrotec")) {
        return "petrotec";
      } else if (document.body.classList.contains("petroassist")) {
        return "petroassist";
      } else {
        return "petrotec-group";
      }
    }
  }
}

export function getBackgroundColor(background_color) {
  switch (background_color) {
    case "white":
      return "bg-white";
    case "light-gray":
      return "bg-gray-100";
    case "medium-gray":
      return "bg-gray-200";
    case "dark-gray":
      return "bg-gray-300";
    default:
      return ""; // Retorna uma string vazia se não houver correspondência
  }
}

export function formatDate(dateString, slashFormat = false) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear();

  return slashFormat
    ? `${day}/${month}/${year}`
    : `${day} · ${month} · ${year}`;
}

export function formatCategory(category) {
  return category
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export async function getGenericContent(locale) {

  console.log("GENERIC CONTENT ")
  const [navbar, footer, region, envs, translations, languages_from_strapi, schema] =
    await Promise.all([
      fetchFromStrapi(
        `navbar?populate=*,menu,menu.image,menu.submenu,menu.submenu.subitem,top_bar,top_bar.subtitems,tablet_image&locale=${locale}`
      ),
      fetchFromStrapi(
        `footer?populate=*,menu.submenu,partnership,partnership.logo&locale=${locale}`
      ),
      fetchUrl(`${process.env.NEXT_PUBLIC_GLOBAL_CONTENT_TYPES}/api/navbar?populate=region,region.country,region.country.website&locale=${locale}`),
      fetchUrl(`${process.env.NEXT_PUBLIC_STRAPI_SERVER}/api/website/env-variable`),
      fetchUrl(`${process.env.NEXT_PUBLIC_GLOBAL_CONTENT_TYPES}/api/website-translation?locale=${locale}`),
      fetchFromStrapi(`i18n/locales`),
      fetchFromStrapi(
        `schema?populate=address,contactPoint,contactPoint.availableLanguages,socialMedia&locale=${locale}`
      ),
    ]);

  console.log(languages_from_strapi);

  const languages = languages_from_strapi.reduce((acc, lang) => {
    const languageName = lang.name.split(" (")[0];
    acc[lang.code] = languageName;
    return acc;
  }, {});

  // Get active locales from environment variables
  const getActiveLocales = () =>
    process.env.ACTIVE_LOCALES ? process.env.ACTIVE_LOCALES.split(",") : ["en"];

  const activeLocales = getActiveLocales();

  let filteredLanguages = Object.fromEntries(
    Object.entries(languages).filter(([key]) => activeLocales.includes(key))
  );

  const updatedFilteredLanguages = Object.fromEntries(
    Object.entries(filteredLanguages).map(([key, value]) => [
      key,
      translations?.data?.attributes[key.toUpperCase()] || value, // Normalize key to uppercase and fallback to original value
    ])
  );

  return {
    navbar: navbar ? navbar : null,
    footer: footer ? footer : null,
    languages: updatedFilteredLanguages,
    websiteType: getWebsiteType(false),
    websiteTitle: process.env.WEBSITE_TITLE,
    GOOGLE_ANALYTICS: process.env.GOOGLE_ANALYTICS
      ? process.env.GOOGLE_ANALYTICS
      : null,
    regions: region ? region.data.attributes.region : [],
    global_website: region
      ? region.data.attributes.petrotec_global
      : process.env.GROUPWEBSITE,
    locale,
    defaultLocale: process.env.DEFAULT_LOCALE || "en",
    translations: translations?.data?.attributes || {},
    schema: schema ? schema : null,
  };
}

export function buildInternalLink(link) {
  if (!link || !link.internalLink || !link.internalLink.postType) {
    return "#";
  }

  switch (link.internalLink.postType) {
    case "pages":
      return "/" + link.internalLink.slug;
    case "business-segments":
      return "/business-segments/" + link.internalLink.slug;
    case "news":
      return "/news/" + link.internalLink.slug;
    case "products":
      return "/products/" + link.internalLink.slug;
    case "product-categories":
      return "/product-category/" + link.internalLink.slug;
    case "services":
      return "/services/" + link.internalLink.slug;
    default:
      return "#";
  }
}

export function localizationMap(page, base = "") {
  return page?.localizations?.data?.reduce((acc, localization) => {
    const { locale, slug } = localization.attributes;
    console.log("locale slug", locale, slug);
    if (locale && slug) {
      acc[locale] = `/${locale}${base}/${slug}`;
    } else if (locale) {
      acc[locale] = `/${locale}${base}`;
    }
    return acc;
  }, {});
}

export function prefix(path) {
  return path;
}

export function localizePath(path, locale, passedDefaultLocale) {
  const basePath = (process.env.NEXT_PUBLIC_BASE_PATH || "").replace(/\/$/, "");
  const defaultLocale =
    passedDefaultLocale ||
    process.env.NEXT_PUBLIC_DEFAULT_LOCALE ||
    process.env.DEFAULT_LOCALE ||
    "en";
  const localePrefix =
    !locale || locale === defaultLocale ? "" : `/${locale}`;

  const cleanPath = path.startsWith("/") ? path : `/${path}`;

  // Combine basePath + localePrefix + path
  let fullPath = `${basePath}${localePrefix}${cleanPath}`;

  // Remove double slashes
  return fullPath.replace(/\/+/g, "/");
}



// Let's redefine the signature to be more useful
export function generateAlternates(page, basePath = "") {
  const activeLocales = process.env.ACTIVE_LOCALES
    ? process.env.ACTIVE_LOCALES.split(",")
    : ["en"];
  const defaultLocale = process.env.DEFAULT_LOCALE || "en";
  const baseUrl = process.env.NEXT_PUBLIC_STRAPI_CLIENT || "";
  const countryCode = process.env.NEXT_PUBLIC_ISO_COUNTRY_CODE;

  const alternates = [];
  const cleanBase = basePath.replace(/\/$/, ""); // Remove trailing slash if present

  const buildUrl = (locale, slug) => {
    const localePrefix = locale === defaultLocale ? "" : `/${locale}`;
    const safeSlug = slug || "";
    // Construct path: /locale/base/slug (handling empty base and locale)
    const path = `${localePrefix}${cleanBase ? `/${cleanBase}` : ""}/${safeSlug}`;
    const cleanPath = path.replace(/\/+/g, "/"); // Ensure no double slashes
    return `${baseUrl}${cleanPath}`;
  };

  const addAlternate = (locale, slug) => {
    let hreflang = locale;
    if (countryCode) {
      hreflang = `${locale}-${countryCode}`;
    }
    alternates.push({
      hreflang: hreflang,
      href: buildUrl(locale, slug)
    });
  };

  // Main Page
  if (page.locale && activeLocales.includes(page.locale)) {
    addAlternate(page.locale, page.slug);
  }

  // Localizations
  if (page.localizations && page.localizations.data) {
    page.localizations.data.forEach((loc) => {
      if (activeLocales.includes(loc.attributes.locale)) {
        addAlternate(loc.attributes.locale, loc.attributes.slug);
      }
    });
  }

  return alternates;
}
